import { translate } from 'loankeeper-common/helpers'

export default (key) => translate(`frm_auth_loanevent_history-${key}`)
export const translateLKMessage = (key) => translate(`LKMESSAGE-${key}`)
